import { RootState } from '../../../app/store';
import { decryptText } from '../../../utils/encryptionUtils';
import ActivitiesW from './activitiesByAppointment';
import ActivitiesCheck from './activitiesByAppointmentCheck';
import { useSelector } from 'react-redux';

const ActivitiesByAppointment = () => {
    const state: any = useSelector((state: RootState) => state.user);
    const decryptedString = decryptText(state.user.isCheckWeb);
    const isCheckWeb = decryptedString === 'true';

  return  isCheckWeb ? <ActivitiesCheck /> : < ActivitiesW/>;
};

export default ActivitiesByAppointment;